var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{attrs:{"placeholder":"请选择","display-render":_vm.displayRender,"options":_vm.userTreeData},on:{"change":_vm.selectUser},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }